import React from 'react'
import { Container, Card } from 'react-bootstrap';

export default function Home() {
  return (
    <>
      <Container>
        <Card className="text-center">
          <Card.Body>
              <div className="loading-animation">
                <div className="preloader"></div>
                <h4>En desarrollo...</h4>
              </div>
          </Card.Body>
        </Card>
      </Container>
    </>
  )
}
